import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { TrendingUp } from "lucide-react";
import { rp } from "@/lib/format";

const SHORT = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
const label = (p) => `${SHORT[Number(p.slice(5, 7)) - 1]} ${p.slice(2, 4)}`;
const compact = (n) => (n >= 1e6 ? `${(n / 1e6).toLocaleString("id-ID", { maximumFractionDigits: 1 })} jt` : n >= 1e3 ? `${Math.round(n / 1e3)} rb` : `${n}`);

const Tip = ({ active, payload }) => (active && payload?.length ? (
  <div className="bg-white border border-slate-200 rounded-xl px-3 py-2 shadow-lg text-xs">
    <div className="font-bold text-slate-900">{label(payload[0].payload.period)}</div>
    <div className="text-amber-600 font-bold">{rp(payload[0].value)}</div>
    <div className="text-slate-500">{payload[0].payload.count} transfer</div>
  </div>
) : null);

export const FeeTrendChart = ({ data }) => {
  const rows = data || [];
  const last = rows.at(-1)?.fee_total || 0;
  const prev = rows.at(-2)?.fee_total || 0;
  const diff = prev ? Math.round(((last - prev) / prev) * 100) : null;
  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 mb-5" data-testid="fee-trend-chart">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          <div className="font-bold text-slate-900 flex items-center gap-2"><TrendingUp className="h-4 w-4 text-amber-600" />Tren Pendapatan Biaya (12 Bulan)</div>
          <div className="text-xs text-slate-500">Naik-turun pendapatan Biaya Layanan Sistem per bulan</div>
        </div>
        {diff !== null && (
          <span data-testid="fee-trend-diff" className={`text-xs font-bold px-2.5 py-1 rounded-full ${diff >= 0 ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-700"}`}>
            {diff >= 0 ? "▲" : "▼"} {Math.abs(diff)}% vs bulan lalu
          </span>
        )}
      </div>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={rows} margin={{ top: 8, right: 8, left: -8, bottom: 0 }}>
            <defs>
              <linearGradient id="feeFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#f59e0b" stopOpacity={0.45} />
                <stop offset="100%" stopColor="#f59e0b" stopOpacity={0.02} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
            <XAxis dataKey="period" tickFormatter={label} tick={{ fontSize: 11, fill: "#64748b" }} tickLine={false} axisLine={false} />
            <YAxis tickFormatter={compact} tick={{ fontSize: 11, fill: "#64748b" }} tickLine={false} axisLine={false} width={48} />
            <Tooltip content={<Tip />} />
            <Area type="monotone" dataKey="fee_total" stroke="#d97706" strokeWidth={2.5} fill="url(#feeFill)" dot={{ r: 3, fill: "#d97706" }} activeDot={{ r: 5 }} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
